import React from 'react';
import {Form, Grid} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import '../../priceColorModal.scss';


const SearchFormMany = ({handleChange, startDate, endDate}) => {
  return (
    <React.Fragment>
      <Grid.Column width={4}>
        <DatePicker
          placeholderText="Fecha Inicial"
          className="tcc-datepicker"
          showMonthYearPicker
          selected={startDate}
          dateFormat="MM/yyyy"
          onChange={(value) => handleChange('startDate', value)}
          locale='es'
          customInput={<Form.Input icon='calendar' label='Fecha inicial' />}
        />
      </Grid.Column>
      <Grid.Column width={4}>
        <DatePicker
          placeholderText="Fecha Final"
          className="tcc-datepicker"
          showMonthYearPicker
          selected={endDate}
          dateFormat="MM/yyyy"
          minDate={startDate}
          onChange={(value) => handleChange('endDate', value)}
          locale='es'
          customInput={<Form.Input icon='calendar' label='Fecha final' />}
        />
      </Grid.Column>
    </React.Fragment>
  );
};

export default SearchFormMany;
